import { ExternalLink, Gift, Sparkles, Star } from 'lucide-react';

const Offers = () => {
  const offers = [
    {
      id: 1,
      name: 'PUB Casino',
      url: 'https://www.pubcasino.co.uk/',
      bonus: '100% up to £100',
      description: 'Double your first deposit and start your journey with extra credit. PUB Casino combines classic pub atmosphere with modern gaming excitement.',
      icon: <Gift className="w-8 h-8" />,
      color: 'from-red-600 to-red-800'
    },
    {
      id: 2,
      name: 'NRG',
      url: 'https://nrg.bet/',
      bonus: '200% on first deposit + 100 free spins',
      description: 'Triple your money and spin 100 times on the house. NRG delivers high-energy gaming with one of the most generous welcome packages in the UK.',
      icon: <Sparkles className="w-8 h-8" />,
      color: 'from-orange-600 to-red-600'
    },
    {
      id: 3,
      name: 'Mr.Play',
      url: 'https://www.mrplay.com/',
      bonus: '100 spins + 100% up to £200 bonus',
      description: 'Get 100 free spins plus match your deposit up to £200. Mr.Play offers premium entertainment with a welcome package that keeps giving.',
      icon: <Star className="w-8 h-8" />,
      color: 'from-purple-600 to-red-600'
    }
  ];

  return (
    <section id="offers" className="py-20 bg-regal-dark">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">
            Exclusive Casino Offers
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Handpicked bonuses from trusted UK casinos. Each offer brings real value and genuine excitement to your gaming experience.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {offers.map((offer, index) => (
            <div
              key={offer.id}
              itemScope
              itemType="https://schema.org/Offer"
              className={`bg-regal-gray rounded-xl overflow-hidden border-2 border-gray-800 hover:border-regal-red transition-all transform hover:scale-105 ${
                index === 1 ? 'md:scale-105 md:border-regal-red' : ''
              }`}
            >
              <div className={`bg-gradient-to-r ${offer.color} p-6 flex items-center justify-between`}>
                <div className="text-white">
                  {offer.icon}
                </div>
                <span className="text-white font-bold text-lg" itemprop="name">{offer.name}</span>
              </div>
              
              <div className="p-6">
                <div className="mb-4">
                  <span className="text-regal-red font-bold text-2xl" itemprop="description">{offer.bonus}</span>
                </div>
                <p className="text-gray-300 mb-6 leading-relaxed" itemprop="description">
                  {offer.description}
                </p>
                <a
                  href={offer.url}
                  target="_blank"
                  rel="noopener noreferrer nofollow sponsored"
                  className="w-full bg-regal-red hover:bg-red-700 text-white py-3 px-6 rounded-lg font-semibold transition-all flex items-center justify-center gap-2"
                  itemprop="url"
                >
                  Claim at {offer.name}
                  <ExternalLink size={18} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Offers;

